import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ill_spot_success_scan_stt.svg'
import _imports_1 from '@/app/ui/assets/svg/ill_spot_failed_scan_stt.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_f_check_circle.svg'
import _imports_3 from '@/app/ui/assets/svg/close-circle.svg'
import _imports_4 from '@/app/ui/assets/svg/sti-reverse-scan/scan-empty-state.svg'
import _imports_5 from '@/app/ui/assets/svg/download-new.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-58134340")

_pushScopeId("data-v-58134340")
const _hoisted_1 = {
  "data-testid": "scan-handover-top-panel",
  class: "flex gap-4 w-full rounded-xl bg-white relative"
}
const _hoisted_2 = { class: "flex flex-col gap-4 flex-1 min-w-0" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col items-center gap-2"
}
const _hoisted_4 = { class: "relative flex items-center justify-center" }
const _hoisted_5 = { class: "flex flex-wrap gap-1.5 justify-center" }
const _hoisted_6 = { class: "flex justify-center" }
const _hoisted_7 = {
  key: 1,
  "data-testid": "scan-handover-scan-success-feedback",
  class: "flex flex-col items-center gap-2"
}
const _hoisted_8 = { class: "relative flex items-center justify-center" }
const _hoisted_9 = {
  key: 0,
  src: _imports_0,
  alt: "success"
}
const _hoisted_10 = {
  key: 1,
  src: _imports_1,
  alt: "failed"
}
const _hoisted_11 = {
  key: 0,
  class: "flex flex-row items-center gap-2 max-w-max rounded-lg text-gray-lp-300 bg-green-lp-1300 p-2 text-center border border-green-lp-700"
}
const _hoisted_12 = {
  key: 0,
  class: "text-sm font-bold"
}
const _hoisted_13 = {
  key: 1,
  class: "flex flex-row items-center gap-1"
}
const _hoisted_14 = { class: "text-sm font-bold" }
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  class: "w-6 h-6 flex-1",
  src: _imports_2,
  alt: "check-circle"
}, null, -1)
const _hoisted_16 = {
  key: 1,
  class: "flex flex-row items-center gap-2 max-w-max rounded-lg text-gray-lp-300 bg-red-lp-1300 p-2 text-center border border-red-lp-2400"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "flex flex-row items-center gap-1"
}
const _hoisted_19 = { class: "text-sm font-bold" }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = /*#__PURE__*/_createVNode("img", {
  class: "w-6 h-6 flex-1",
  src: _imports_3,
  alt: "check-circle"
}, null, -1)
const _hoisted_22 = {
  key: 2,
  class: "flex flex-row items-center justify-center"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  alt: "scan-empty-state"
}, null, -1)
const _hoisted_24 = { class: "flex flex-col gap-1.5 input-scan-handover-v2" }
const _hoisted_25 = {
  key: 0,
  "data-testid": "scan-handover-failed-scan-panel",
  class: "w-44 flex-shrink-0 flex flex-col gap-2 absolute right-0 rounded-lg bg-white border border-gray-lp-1400 p-2"
}
const _hoisted_26 = { class: "flex items-center justify-between" }
const _hoisted_27 = { class: "text-sm font-bold text-black" }
const _hoisted_28 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  class: "w-4 h-4",
  alt: "download"
}, null, -1)
const _hoisted_29 = {
  class: "flex flex-col gap-1 overflow-y-auto",
  style: {"max-height":"112px"}
}
const _hoisted_30 = { class: "text-xs font-semibold text-red-lp-2400" }
const _hoisted_31 = { class: "text-10px text-gray-lp-300" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_LpInput = _resolveComponent("LpInput")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.isScanning)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_Skeleton, {
                width: "105px",
                height: "92px"
              })
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_Skeleton, {
                width: "6.5rem",
                height: "1.5rem"
              }),
              _createVNode(_component_Skeleton, {
                width: "6.5rem",
                height: "1.5rem"
              }),
              _createVNode(_component_Skeleton, {
                width: "6.5rem",
                height: "1.5rem"
              })
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_Skeleton, {
                width: "19.5rem",
                height: "3rem"
              })
            ])
          ]))
        : _createCommentVNode("", true),
      ((_ctx.lastScanRow?.stt?.sttNo && !_ctx.isScanning) || _ctx.lastScanRow.error)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              (_ctx.isDuplicateScan || _ctx.lastScanRow.isSuccess)
                ? (_openBlock(), _createBlock("img", _hoisted_9))
                : (_openBlock(), _createBlock("img", _hoisted_10))
            ]),
            (_ctx.isDuplicateScan || _ctx.lastScanRow.isSuccess)
              ? (_openBlock(), _createBlock("div", _hoisted_11, [
                  (_ctx.isDuplicateScan)
                    ? (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.$t("STT Sudah Di Scan")), 1))
                    : (_openBlock(), _createBlock("div", _hoisted_13, [
                        _createVNode("span", _hoisted_14, _toDisplayString(_ctx.lastScanRow.stt?.sttNo), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("handoverV2.update.common.successScan")), 1)
                      ])),
                  _hoisted_15
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_16, [
                  (_ctx.lastScanRow.error)
                    ? (_openBlock(), _createBlock("span", _hoisted_17, _toDisplayString(_ctx.lastScanRow.error), 1))
                    : (_ctx.lastScanRow.stt?.sttNo)
                      ? (_openBlock(), _createBlock("div", _hoisted_18, [
                          _createVNode("span", _hoisted_19, _toDisplayString(_ctx.lastScanRow.stt?.sttNo), 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("handoverV2.update.common.failedScan")), 1)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_20, _toDisplayString(_ctx.$t("handoverV2.update.common.failedApi")), 1)),
                  _hoisted_21
                ]))
          ]))
        : (!_ctx.isScanning)
          ? (_openBlock(), _createBlock("div", _hoisted_22, [
              _hoisted_23
            ]))
          : _createCommentVNode("", true),
      _createVNode("div", _hoisted_24, [
        _createVNode(_component_LpInput, {
          "data-testid": "scan-handover-scan-input",
          ref: "scanInputHandover",
          modelValue: _ctx.sttNoInputValueModel,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.sttNoInputValueModel = $event)),
          sizeInput: "24px",
          bold: !!_ctx.sttNoInputValueModel,
          labelStacked: _ctx.$t('handoverV2.update.scan.placeholder'),
          placeholder: _ctx.$t('handoverV2.update.scan.example'),
          onEnter: _ctx.onEnter,
          onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('focus'))),
          onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('blur')))
        }, null, 8, ["modelValue", "bold", "labelStacked", "placeholder", "onEnter"])
      ])
    ]),
    (_ctx.failedScans.length)
      ? (_openBlock(), _createBlock("div", _hoisted_25, [
          _createVNode("div", _hoisted_26, [
            _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("handoverV2.update.common.failedScanDownloadTitle")), 1),
            _createVNode("button", {
              type: "button",
              "data-testid": "scan-handover-failed-scan-download",
              class: "flex-shrink-0 p-1 rounded hover:bg-gray-lp-200 transition-colors",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.downloadExcel && _ctx.downloadExcel(...args)))
            }, [
              _hoisted_28
            ])
          ]),
          _createVNode("div", _hoisted_29, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.failedScans, (item, index) => {
              return (_openBlock(), _createBlock("div", {
                key: `${item.sttNo}_${index}`,
                "data-testid": `scan-handover-failed-scan-item-${index}`,
                class: ["flex flex-col py-1.5  border-gray-lp-1400", [
            { 'border-b-0': index === _ctx.failedScans.length - 1 },
            { 'border-b': index !== _ctx.failedScans.length - 1 }
          ]]
              }, [
                _createVNode("span", _hoisted_30, _toDisplayString(item.sttNo), 1),
                _createVNode("span", _hoisted_31, _toDisplayString(item.message), 1)
              ], 10, ["data-testid"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})